<template>
  <div class="deliver-goods-order">
    <div class="title">{{$t('crm_deliver_goods_order.ddxqsbslb')}}</div>
    <custom-table
      :maxHeight="150"
      :data="tableList"
      :column="tableColumn"
      :index="true"
      @filter="filterChange"
      @sort="sortChange"
      :slots="['receivingInfo']"
    >
      <template v-slot:receivingInfo="scope">
        <el-tooltip
          placement="bottom"
          effect="light"
          v-if="scope.row.receivingInfo"
        >
          <div slot="content">
            <div style="padding: 2px 8px">
              <p style="font-size: 14px; line-height: 24px">{{$t('crm_deliver_goods_order.shou_huo_ren')}}： {{ scope.row.infoDetail.consigneeName }}</p>
              <p style="font-size: 14px; line-height: 24px">{{$t('crm_deliver_goods_order.dian_hua')}}： {{ scope.row.infoDetail.consigneePhone }}</p>
              <p style="font-size: 14px; line-height: 24px">
                {{$t('crm_deliver_goods_order.di_zhi')}}： {{ scope.row.infoDetail.receiveAddress }}
              </p>
            </div>
          </div>
          <el-button type="text">{{$t('Common.com_details')}}</el-button>
        </el-tooltip>
      </template>
    </custom-table>
  </div>
</template>

<script>
/** 订单需求设备数量表 */
import apis from '@/utils/apis';

export default {
  mixins: [],
  props: {
    orderId: [String, Number],
  },
  data() {
    return {
      tableCode: 'deliver_goods_order',
      tableList: [],
      totalRows: 1,
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
    };
  },
  watch: {
    orderId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableList();
        }
      },
    },
  },
  methods: {
    listAdapter(list) {
      return list.map((item) => {
        const receivingInfo = item.receivingInfo || '';
        const infoArr = receivingInfo.split('/');
        return {
          ...item,
          infoDetail: {
            consigneeName: infoArr[0],
            consigneePhone: infoArr[1],
            receiveAddress: infoArr[2],
          },
        };
      });
    },
    getTableList() {
      this.$getJSON(apis.transferOrderGoodsList, {
        orderId: this.orderId,
      }).then((res) => {
        this.tableList = this.listAdapter(res.data);
        this.$emit('getList', this.tableList);
      });
    },
  },
  mounted() {
    this.getTableColumn();
  },
};
</script>

<style lang="scss" scoped>
.deliver-goods-order {
  .title {
    line-height: 20px;
    margin-bottom: 6px;
    color: #35405b;
    font-weight: bold;
    font-size: 14px;
    margin-top: 16px;
  }

  // 去除底部横线
  .el-table::before {
    height: 0;
  }
}
</style>
